<!--
  Единая кнопка создания ЭДО-документа.
  Держит модалку выбора типа документа и общий route mapping для всех входов.
-->
<template>
  <base-primary-button
    v-bind="$attrs"
    :class="buttonClass"
    type="button"
    :icon="icon"
    @click="openModal"
  >
    {{ label }}
  </base-primary-button>

  <EdoCreateDocumentModal
    v-if="showCreateDocumentModal"
    :initial-document-type="initialDocumentType"
    :initial-integration-id="modalIntegrationId"
    :is-submitting="edoDocumentStore.isSubmitting"
    :source-order-id="sourceOrderId"
    :source-organization-inn="sourceOrganizationInn"
    @select="handleCreateDocumentSelect"
    @close="closeModal"
  />
</template>

<script>
import EdoCreateDocumentModal from "@/components/Edo/CreateDocumentModal.vue";

import { useEdoDocumentStore } from "@/stores/edoDocumentStore";
import {
  getSelectedSabyIntegrationId,
  setSelectedSabyIntegrationId,
} from "@/utils/edoIntegrationContext";

const DOCUMENT_ROUTES = {
  consignment_note: "EdoConsignmentNoteBuild",
  transport_order: "EdoTransportOrderBuild",
  forwarder_order: "EdoForwarderOrderBuild",
  forwarder_receipt: "EdoForwarderReceiptBuild",
};

const DOCUMENT_BACKEND_TYPES = {
  consignment_note: "ConsignmentNote",
  transport_order: "TransportOrder",
  forwarder_order: "ForwarderOrder",
  forwarder_receipt: "ForwarderReceipt",
};

export default {
  name: "EdoCreateDocumentButton",

  inheritAttrs: false,

  components: {
    EdoCreateDocumentModal,
  },

  props: {
    sourceOrderId: {
      type: [String, Number],
      default: null,
    },
    sourceOrganizationInn: {
      type: [String, Number],
      default: null,
    },
    sourceReturnTab: {
      type: String,
      default: "edo_documents",
    },
    integrationId: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      default: "Создать ЭДО",
    },
    icon: {
      type: String,
      default: "clipboardCheck",
    },
    buttonClass: {
      type: [String, Array, Object],
      default: "nav-btn",
    },
    initialDocumentType: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      showCreateDocumentModal: false,
      selectedIntegrationId: this.initialIntegrationId(),
    };
  },

  computed: {
    edoDocumentStore() {
      return useEdoDocumentStore();
    },

    modalIntegrationId() {
      return this.integrationId || this.selectedIntegrationId;
    },
  },

  methods: {
    openModal() {
      this.selectedIntegrationId = this.initialIntegrationId();
      this.showCreateDocumentModal = true;
    },

    closeModal() {
      this.showCreateDocumentModal = false;
    },

    async handleCreateDocumentSelect({
      type,
      integrationId,
      sourceType,
      sourceOrderId,
      xmlFileBase64,
    }) {
      const routeName = DOCUMENT_ROUTES[type];
      if (!routeName) return;

      this.selectedIntegrationId = integrationId;
      setSelectedSabyIntegrationId(integrationId);

      if (sourceType === "xml") {
        const document = await this.edoDocumentStore.importDocumentXml({
          documentType: DOCUMENT_BACKEND_TYPES[type],
          integrationId,
          xmlBase64: xmlFileBase64,
          sourceLinks: {},
        });
        this.closeModal();
        if (document?.id) {
          this.$router.push({
            name: "EdoDocumentDetails",
            params: { id: document.id },
            query: { tab: "info" },
          });
        }
        return;
      }

      this.closeModal();

      this.$router.push({
        name: routeName,
        query: this.documentQuery({
          integrationId,
          sourceType,
          sourceOrderId,
          sourceReturnTab: this.sourceReturnTab,
        }),
      });
    },

    documentQuery({ integrationId, sourceType, sourceOrderId, sourceReturnTab }) {
      const query = { integration_id: integrationId };
      if (sourceType === "order" && sourceOrderId) {
        query.source_order_id = sourceOrderId;
        query.source_return_tab = sourceReturnTab;
      }
      return query;
    },

    initialIntegrationId() {
      return this.integrationId || getSelectedSabyIntegrationId();
    },
  },
};
</script>
